import { FlexColumnCenterVertical } from '@main/core-ui';
import { SanitizeHtml } from '@main/pc-core-components';
import React from 'react';

import { StyledRowContainer, StyledSectionWrapper } from './wrappers';

export interface SectionWrapperProps {
  /** title of the item */
  title?: string;
  /** description of the item */
  description: string | React.ReactNodeArray;
  /** Extra buttons or links next to title */
  titleExtras?: React.ReactNode;
  /** children contents */
  children: React.ReactNode;
  /** Title type */
  titleType?: 'h1' | 'sanitizeHtml';
}
/**
 * Base component for a section in Privacy center pages
 */
export const SectionWrapper: React.FC<SectionWrapperProps> = ({
  title,
  description,
  titleExtras,
  titleType = 'h1',
  children,
}) => (
  <StyledSectionWrapper>
    <StyledRowContainer>
      <FlexColumnCenterVertical>
        {title &&
          (titleType === 'h1' ? (
            <h1>{title}</h1>
          ) : (
            <SanitizeHtml html={title} />
          ))}
        <StyledRowContainer>
          <p>
            {typeof description === 'string' ? (
              <SanitizeHtml html={description} />
            ) : (
              description
            )}
          </p>
        </StyledRowContainer>
      </FlexColumnCenterVertical>
      {titleExtras && titleExtras}
    </StyledRowContainer>
    {children}
  </StyledSectionWrapper>
);
